module.exports = require('./helpers/bundle-url').getBundleURL('5kpau') + "logo-dark.eefe0b7f.svg";